<template>
  <v-card class="pa-0 toolbar-avatar" flat>
    <v-skeleton-loader class="pr-0" type="avatar" v-if="!customer" />

    <v-list-item v-else class="pr-0">
      <v-list-item-content class="text-right">
        <v-list-item-title class="headline">
          {{ customer.last_name }} {{ customer.first_name }} {{ customer.middle_name }}
        </v-list-item-title>

        <v-list-item-subtitle>
          <span v-if="customer.age">{{ customer.age }} лет</span>
          <span v-if="customer.full_address">, {{ customer.full_address }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-avatar color="grey">
        <img src="@/assets/img/avatar5.png" class="med-card__avatar" />
      </v-list-item-avatar>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: "ToolbarAvatar",

  props: {
    positionRight: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    customer() {
      return this.$store.state.customer.profile;
    },
  },
};
</script>

<style scoped lang="scss">
.toolbar-avatar {
  background: transparent !important;
}
</style>
